export default __webpack_public_path__ + "static/media/reglogin-bg-id.9f414e2e.webp";